<template>
	<main id="zakat-container" class="vx-row justify-center mt-12">
		<div class="vx-col w-full md:w-2/3 lg:w-1/2 xl:w-1/2">
			<br><br>	
			<vx-card  class="tab mb-12">
				<header class="mb-6">
					<h3 class="mb-4">
						<strong class="text-warning mr-2">Kalkulator</strong>
						<strong class="text-primary">Zakat</strong>
					</h3>
				</header>
				<section class="flex items-center">
					<vs-tabs>
						<vs-tab label="Profesi">
		                    <zakat-penghasilan @payZakat="payZakat" />
		                </vs-tab>
		                <vs-tab label="Harta">
		                    <zakat-harta @payZakat="payZakat" />
		                </vs-tab>
		                <vs-tab label="Perdagangan">
		                    <zakat-perdagangan @payZakat="payZakat" />
		                </vs-tab>
		                <vs-tab label="Simpanan">
		                    <zakat-simpanan @payZakat="payZakat" />
		                </vs-tab>
					</vs-tabs>
				</section>
			</vx-card>
			
		</div>
			
	</main>	
</template>
<script>
import vSelect from 'vue-select'
import Logo from '@/assets/images/zakat.svg'

const NoZakatApp = {
  // template: `<h3>Silahkan Pilih Jenis Zakat Anda222</h3>`
  render (createElement) {
    const classes = ['text-center']

    return createElement(
      'div',
      {
        attrs: { class: classes.join(' ') }
      },
      [
        createElement(
          'img',
          { 
            attrs: { 
              class: 'w-1/2 lg:w-2/3 mb-6',
              src: Logo
            } 
          }
        ),
        createElement(
          'h4',
          { attrs: { class: 'text-center' } },
          'Silahkan Pilih Jenis Zakat'
        )
      ]
    )
  }
}

export default {
  methods: {
    payZakat (payload) {
      if (payload.total > 0) {
        this.$vs.loading()

        setTimeout(() => {
          this.$vs.loading.close();
          let nextLink = `/bayar-zis?amount=${payload.total}&t=${payload.type}`;
          if(this.$route.query.mt) {
            nextLink += `&mt=${this.$route.query.mt}`;
          }
          this.$router.push(nextLink);
        }, 1000)
      }
					
    }
  },
  components: {
    vSelect,
    ZakatPenghasilan: () => import('./components/ZakatPenghasilan.vue'),
    ZakatMaal: () => import('./components/ZakatMaal.vue'),
    ZakatHarta: () => import('./components/ZakatHarta.vue'),
    ZakatPerdagangan: () => import('./components/ZakatPerdagangan.vue'),
    ZakatSimpanan: () => import('./components/ZakatSimpanan.vue'),
    NoZakatApp
  },
  watch: {
    typeZakat (val) {
      this.$vs.loading({
        container: '#zx-app-container',
        scale: 0.6
      })

      if (val === null) {
        this.currentZakatApp = 'NoZakatApp'
      } else if (val.id === 'penghasilan') {
        this.currentZakatApp = 'ZakatPenghasilan'

      } else if (val.id === 'maal') {
        this.currentZakatApp = 'ZakatMaal'	
      }

      setTimeout(() => {
        this.$vs.loading.close('#zx-app-container > .con-vs-loading')
      }, 1000)
    }
  },
  data: () => ({
    currentZakatApp: 'NoZakatApp',
    typeZakat: null,
    typesZakat: [
      { id: 'penghasilan', label: 'Zakat Profesi' },
      { id: 'maal', label: 'Zakat Maal' }
    ]
  })
}
</script>